import React, { useContext } from 'react'
import { ReportEmbed } from 'Components'
import { GlobalContext } from 'Utils'
import { get } from 'lodash'


export const ReportsSales = ({ url, dashboardId }) => {

  const context = useContext(GlobalContext)
  const codDistribuidor = get(context, 'currentUser.codDistribuidor')

  return (
    <ReportEmbed idReport="sales" currentUrl={url} dashboardId={dashboardId} params={{ codDistribuidor: codDistribuidor }}/>
  )
}
